import React, { useMemo, useRef, useState, useEffect } from 'react';
import * as mat from './lib/jsmatrix';
import NumberFormat from 'react-number-format';


import { v4 as uuidv4 } from 'uuid';
import { formatNumber } from './utils.js'

const PI2 = Math.PI * 2.0;
function normalizeAngle(angle) {
    let result = angle % PI2;
    // modulo takes sign of dividend => normalize

    if (result < 0) {
        result += PI2;
    }

    return result;
}

function AngleSlider({ angle, angleName = "alpha", handleChange, precision = 2, clockwise = true,
    angleMin = 0, angleMax = 360 }) {


    angle = normalizeAngle(angle);


    let angleDeg = mat.rad2deg(angle);

    // clamp
    angleDeg = Math.max(angleMin, Math.min(angleMax, angleDeg));
    const ad = angleMax - angleMin;

    const convDeg2Perc = a => (a - angleMin) / ad * 100;
    const convPerc2Deg = a => angleMin + a / 100 * ad;

    const sliderAngle = convDeg2Perc(angleDeg);

    return (
        <div>
            <div>
                {angleName} : {formatNumber(angleDeg, precision)}[deg]
      </div>
            <input type="range" min="0" max="100" value={clockwise ? 100 - sliderAngle : sliderAngle} className="angleSlider"
                onChange={e => handleChange(mat.deg2rad(convPerc2Deg(clockwise ? 100 - Number(e.target.value) : Number(e.target.value))))}></input>
        </div>
    );
}

function CheckBox({ checked, labelText, handleChange }) {

    const id = useMemo(() => uuidv4(), []);

    return <div>
        <input
            name={id} type="checkbox"
            checked={checked}
            onChange={e =>
                handleChange(e.target.checked)} />
        <label htmlFor={id}> {labelText}</label>
    </div>;
}

function ValueSlider({ value, valueName, handleChange, min = 0, max = 100, step = 1, precision = 2 }) {

    return (
        <div>
            <div>
                {valueName} : {formatNumber(value, precision)}
            </div>
            <input type="range" min={min} max={max} step={step} value={value} className="valueSlider"
                onChange={e => { handleChange(Number(e.target.value)) }}></input>
        </div>
    );
}


function NumberInput({ value, valueName, handleChange, precision = 2,
    ...otherProps }) {

    const [vs, setVs] = useState(0);

    useEffect(() => {
        setVs(() => value);
    }, [value]);
    // const vs = value.toFixed(precision);
    return (
        <div>
            {valueName}
            <NumberFormat value={vs} allowEmptyFormatting
                {...otherProps}
                onValueChange={e => {
                    const val = e.floatValue;
                    setVs(val);
                    if (val !== value) {
                        handleChange(val);
                    }
                }} />
        </div>
    );

}

function NumberInputTimeout({ value, valueName, handleChange, timeout = 1000, precision = 2, ...otherProps }) {

    // const vs = value.toFixed(precision);
    const vs = value;
    const timeRef = useRef(null);

    const valChanged = e => {
        if (timeRef.current !== null) {
            clearTimeout(timeRef.current);
        }

        timeRef.current = setTimeout(() => {
            handleChange(e);
        }, timeout);
    };
    return (
        <div>
            {valueName}
            <NumberFormat value={vs} allowEmptyFormatting
                onValueChange={e => valChanged(e.floatValue)}
                {...otherProps}
            />
        </div>
    );

}


export {
    AngleSlider,
    CheckBox,
    NumberInput,
    ValueSlider,
    NumberInputTimeout
}